import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { PrimaryButton } from '../../buttons/primary/primary-button';
import { SecondaryButton } from '../../buttons/secondary/secondary-button';
import { useStepperCardContext } from '../provider/stepper-card.provider';
import { useStepperContext } from '../provider/stepper.provider';

const nextButtonStyle = css`
  margin-left: ${theme.spacing(2)};
`;

export type StepperNextButtonProps = {
  isValid?: boolean;
  isSecondaryButton?: boolean;
  isOptionalStep?: boolean;
  onClick?: () => Promise<void> | void;
  onSubmit?: () => Promise<void> | void;
  trackingId?: string;
  children: string;
  className?: string;
};

export const StepperNextButton = ({
  isOptionalStep = false,
  isSecondaryButton,
  isValid = false,
  onClick,
  onSubmit,
  trackingId,
  children = 'Next',
  className,
  ...rest
}: Partial<StepperNextButtonProps>) => {
  const buttonIsDisabled = !isOptionalStep && !isValid;
  const { nextFunction } = useStepperContext();
  const { step } = useStepperCardContext();
  const Button = isSecondaryButton ? SecondaryButton : PrimaryButton;

  const next = async () => {
    if (onClick) await onClick();
    nextFunction?.(step);
  };

  return (
    <Button
      disabled={buttonIsDisabled}
      className={cx('step-button', nextButtonStyle, className)}
      trackingId={trackingId}
      onClick={() => (onSubmit ? onSubmit() : next())}
      {...rest}
    >
      {children}
    </Button>
  );
};
